'use client';

import { useEffect } from 'react';
import { getCookie } from 'cookies-next';
import parseUserV2 from 'utils/parseUserV2';

export default function GoogleTagDataLayer() {
  const user_token = getCookie('user_token');
  const user = parseUserV2(user_token);

  useEffect(() => {
    if (!window.dataLayer) window.dataLayer = [];
    window.dataLayer.push({
      user,
    });
  }, [user]);

  return null;
}
